import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconMarketing = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.777778 5.02626C0.348299 5.02626 0 5.3798 0 5.81574V8.18416C0 8.6201 0.348299 8.97363 0.777778 8.97363C1.05438 8.97363 1.28576 8.8187 1.42358 8.59814L4.02403 9.39501C3.9426 9.6358 3.88889 9.88942 3.88889 10.1578C3.88889 11.4639 4.93549 12.5263 6.22222 12.5263C7.30358 12.5263 8.20701 11.7721 8.47049 10.7573L11.6667 11.7368V2.26311L1.42358 5.40176C1.28576 5.1812 1.05438 5.02626 0.777778 5.02626ZM5.13552 9.73547L7.35875 10.4166C7.24184 10.9453 6.7776 11.3421 6.22222 11.3421C5.57885 11.3421 5.05556 10.8109 5.05556 10.1578C5.05556 10.0086 5.08569 9.86697 5.13552 9.73547ZM13.6111 1.47363H12.8333C12.6185 1.47363 12.4444 1.65028 12.4444 1.86837V12.1315C12.4444 12.3496 12.6185 12.5263 12.8333 12.5263H13.6111C13.826 12.5263 14 12.3496 14 12.1315V1.86837C14 1.65028 13.826 1.47363 13.6111 1.47363Z",
		fill: "currentColor"
	})
});
export default SvgNavIconMarketing;
